import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { WarehouseReceiptContextOperationsResponse } from './warehouse-receipt-context-operations.response';
import { Guid, Nillable } from '@web/utils';
import { WarehouseReceiptStatus } from '../../enums/warehouse-receipt-status';
import { MultimediaResponse } from '@web/shared/module/multimedia';

@jsonObject
export class WarehouseReceiptDetailsResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly number!: string;

  @jsonMember(String)
  public readonly comment?: Nillable<string>;

  @jsonMember(Date)
  public readonly receiptedAt!: Date;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(Date)
  public readonly approvedAt?: Nillable<Date>;

  @jsonMember(String)
  public readonly status!: WarehouseReceiptStatus;

  @jsonArrayMember(MultimediaResponse)
  public readonly files!: MultimediaResponse[];

  @jsonMember(WarehouseReceiptContextOperationsResponse)
  public readonly contextOperations!: WarehouseReceiptContextOperationsResponse;
}
